import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { TailSpin } from 'react-loader-spinner';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import { TextField } from '@mui/material';
import { HexColorPicker } from "react-colorful";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

// Libraries
import SftGlobalData from '../../library/SftGlobalData';
import Colors from '../../library/Colors';
import './eticket.css';
import FloatingSaveButton from '../../components/FloatingSaveButton';
import FloatingBackButton from '../../components/FloatingBackButton';


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <div>{children}</div>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
  }


const EcustomDetailScreen = (props) =>  {
    const [loading, setLoading] = useState(true);
    const [value, setValue] = useState(0);
    const [name, setName] = useState("");
    const [storeId, setStoreId] = useState("00");
    const [posId, setPosId] = useState("0000");
    const params = useParams();

    // Template & Colors
    const [template, setTemplate] = useState('2');
    const [templates, setTemplates] = useState([]);
    const [color, setColor] = useState(Colors.sft_blue);
    const [textColor, setTextColor] = useState('#FFFFFF');

    // Logo
    const [logo, setLogo] = useState("");

    // Mail settings
    const [mailFromEmail, setMailFromEmail] = useState("");
    const [mailErrorEmail, setMailErrorEmail] = useState("");
    const [mailBccEmail, setMailBccEmail] = useState("");

    let navigate = useNavigate();

    useEffect(() => {
        props.changeScreen('E-custom');
        if(props.api) {
            fetchData();
        }
     },[props.api]);

    const fetchData = () => {
        let postData = {
            sft_id: props.login.sft_status,
            sft_group: props.login.sft_group,
            login: props.login.login,
            key: props.api,
            id: params.listId
        }

        SftGlobalData.post('eticket&action=fetch', postData).then(response => {
            if(response.status == 200){
                // Filter to find the ecustom settings
                const allSettings = response.data.settings || [];
                const ecustomSettings = allSettings.filter(item => String(item.service_type).toLowerCase() === 'ecustom');
                const setting = ecustomSettings.find(s => s.key === params.elementId);

                let currentTemplateId = "2";
                if(setting) {
                    setName(setting.name || "");
                    setStoreId(setting.store_id || "00");
                    setPosId(setting.pos_id || "0000");

                    // Layout
                    currentTemplateId = setting.layout?.template_id || "2";
                    setTemplate(currentTemplateId);
                    setColor(setting.layout?.accent_color || Colors.sft_blue);
                    setTextColor(setting.layout?.accent_text_color || "#FFFFFF");

                    // Logo
                    if(setting.program_vars?.ticket_logo) {
                        setLogo("data:image/jpeg;base64," + setting.program_vars.ticket_logo);
                    }

                    // Mail settings
                    setMailFromEmail(setting.mail_settings?.sender_mail || "");
                    setMailErrorEmail(setting.mail_settings?.error_mail || "");
                    setMailBccEmail(setting.mail_settings?.bcc_mail || "");
                }

                fetchTemplates(currentTemplateId);
            }
        }).catch(() => {
            setLoading(false);
        });
    }

    const fetchTemplates = (currentTemplate) => {
        let postData = {
            sft_id: props.login.sft_status,
            sft_group: props.login.sft_group,
            login: props.login.login,
            key: props.api,
            type: "ECUSTOM",
            active: 1
        }
        SftGlobalData.post('templates&action=fetchHeaders', postData).then(response => {
            const fetchedTemplates = response.data || [];
            setTemplates(fetchedTemplates);

            // Auto-select template if current value is not in the list or if there's only one template
            if(fetchedTemplates.length > 0) {
                const templateExists = fetchedTemplates.some(t => String(t.id) === String(currentTemplate));
                if(!templateExists || fetchedTemplates.length === 1) {
                    setTemplate(String(fetchedTemplates[0].id));
                }
            }

            setLoading(false);
        }).catch(() => {
            setLoading(false);
        });
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const save = () => {
        let postData = {
            sft_group: props.login.sft_group,
            sft_status: props.login.sft_status,
            sft_user_id: props.login.sft_user_id,
            login: props.login.login,
            key: props.api,
            store_id: storeId,
            pos_id: posId,
            id: params.listId,
            element: params.elementId,
            service_type: "ecustom",
            settings: [{
                store_id: storeId,
                pos_id: posId,
                mail_settings: {
                    sender_mail: mailFromEmail,
                    error_mail: mailErrorEmail,
                    bcc_mail: mailBccEmail
                },
                layout: {
                    template_id: template,
                    accent_color: color,
                    accent_text_color: textColor
                }
            }],
            ticket_logo: logo
        }

        SftGlobalData.post('eticket&action=wizardEcustom', postData).then(response => {
            if(response.status == 200){
                props.notify(props.t('savedChanges'), 7500, "top-right", props.theme, 1);
            } else {
                props.notify(props.t('errorOccured'), 7500, "top-right", props.theme, 1);
            }
        });
    }

    const onLogoChange = (e) => {
        let files = e.target.files;
        let fileReader = new FileReader();
        if(files[0].size > 64000){
            props.notify(props.t('fileTooLarge'), 7500, "top-right", props.theme, 1);
            e.target.value = '';
            return;
        }
        fileReader.readAsDataURL(files[0]);

        fileReader.onload = (event) => {
            setLogo(event.target.result);
        }
    }

    const fetchMySftLogo = () => {
        SftGlobalData.post('client&action=fetchLogo', {key: props.api}).then(responseLogo => {
            setLogo(responseLogo.data);
        });
    }

    /*************************************************************************************
    *                             TEMPLATE / COLORS
    *************************************************************************************/
    const templateStep = () => {
        return (
            <div className="rowContainerEvenly" style={{width: '100%'}}>
                <div className='margin_top_10px columnContainerBetween slide-in-blurred-left' style={{width: '45%'}}>
                    <FormControl className={props.theme + '_accent _100perc'}>
                        <InputLabel id="template-select-label">{props.t('template')}</InputLabel>
                        <Select
                            className={props.theme + "_accent " + props.theme + "_text _100perc"}
                            labelId="template-select-label"
                            id="template-select"
                            value={template}
                            label="Template"
                            onChange={(event) => { setTemplate(event.target.value); }}
                            style={{height: 40, paddingTop: 8, paddingBottom: 8}}>
                            {templates.map((tmpl) => (
                                <MenuItem key={tmpl.id} value={tmpl.id}>
                                    {tmpl.title}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <div className='margin_top_10px'>
                        <h4>{props.t('accent_color')}</h4>
                        <hr/>
                        <HexColorPicker color={color} onChange={setColor} />
                        <TextField
                            minRows={1}
                            autoComplete="off"
                            className={props.theme + '_accent _100perc margin_top_10px'}
                            id="colorHex"
                            label={props.t('accent_color')}
                            size={'small'}
                            sx={(props.theme==='light') ? {
                                '& .MuiOutlinedInput-input': { color: Colors.light_text },
                                '& .MuiInputLabel-root': { color: Colors.light_text_accent },
                                borderRadius: 3, marginTop: 0
                            } : {
                                '& .MuiOutlinedInput-input': { color: Colors.dark_text },
                                '& .MuiInputLabel-root': { color: Colors.dark_text_accent },
                                borderRadius: 3, marginTop: 0
                            }}
                            value={color}
                            onChange={(event) => { setColor(event.target.value) }}
                        />
                    </div>
                </div>

                <div className='margin_top_10px columnContainerBetween slide-in-blurred-right' style={{width: '45%'}}>
                    <div className='margin_top_10px'>
                        <h4>{props.t('text_color')}</h4>
                        <hr/>
                        <HexColorPicker color={textColor} onChange={setTextColor} />
                        <TextField
                            minRows={1}
                            autoComplete="off"
                            className={props.theme + '_accent _100perc margin_top_10px'}
                            id="textColorHex"
                            label={props.t('text_color')}
                            size={'small'}
                            sx={(props.theme==='light') ? {
                                '& .MuiOutlinedInput-input': { color: Colors.light_text },
                                '& .MuiInputLabel-root': { color: Colors.light_text_accent },
                                borderRadius: 3, marginTop: 0
                            } : {
                                '& .MuiOutlinedInput-input': { color: Colors.dark_text },
                                '& .MuiInputLabel-root': { color: Colors.dark_text_accent },
                                borderRadius: 3, marginTop: 0
                            }}
                            value={textColor}
                            onChange={(event) => { setTextColor(event.target.value) }}
                        />
                    </div>

                    {/* Color preview */}
                    <div className='margin_top_10px'>
                        <h4>{props.t('preview')}</h4>
                        <hr/>
                        <div style={{
                            backgroundColor: color,
                            color: textColor,
                            padding: 20,
                            borderRadius: 8,
                            textAlign: 'center'
                        }}>
                            {props.t('preview')}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    /*************************************************************************************
    *                                   LOGO
    *************************************************************************************/
    const logoStep = () => {
        return (
            <div className='rowContainerCenter'>
                <div className='_50perc slide-in-blurred-top'>
                    <h4>Logo</h4>
                    <hr/>
                    <div className='flex_center_column'>
                        <br/>
                        <img alt="Logo" src={(logo !== "data:image/jpeg;base64," && logo !== "" ? logo : SftGlobalData.noimage)} style={{width: 300, height: 100, objectFit: 'contain'}}/>
                    </div>
                    <br/>
                    <label className="text-white">{props.t('select_file')}</label>
                    <input type="file" className="form-control" name="image" onChange={onLogoChange} accept="image/jpeg, image/png, image/jpg"/>
                    {props.login?.sft_status != "0" && (
                        <button
                            className={"modal_button_container_no_margin__button margin_top_10px _100perc"}
                            onClick={() => { fetchMySftLogo() }}>
                            {props.t('get_from_licence')}
                        </button>
                    )}
                </div>
            </div>
        );
    }

    /*************************************************************************************
    *                                   MAIL SETTINGS
    *************************************************************************************/
    const mailStep = () => {
        return (
            <div className='rowContainerCenter' style={{width: '100%'}}>
                <div className='_50perc slide-in-blurred-left'>
                    <h4>{props.t('mail_settings')}</h4>
                    <hr/>

                    <TextField
                        minRows={1}
                        autoComplete="off"
                        className={props.theme + '_accent _100perc margin_top_10px'}
                        id="mailFromEmail"
                        label={props.t('sender_email')}
                        size={'small'}
                        sx={(props.theme==='light') ? {
                            '& .MuiOutlinedInput-input': { color: Colors.light_text },
                            '& .MuiInputLabel-root': { color: Colors.light_text_accent },
                            borderRadius: 3
                        } : {
                            '& .MuiOutlinedInput-input': { color: Colors.dark_text },
                            '& .MuiInputLabel-root': { color: Colors.dark_text_accent },
                            borderRadius: 3
                        }}
                        value={mailFromEmail}
                        onChange={(event) => { setMailFromEmail(event.target.value) }}
                    />

                    <TextField
                        minRows={1}
                        autoComplete="off"
                        className={props.theme + '_accent _100perc margin_top_10px'}
                        id="mailBccEmail"
                        label={"BCC"}
                        size={'small'}
                        sx={(props.theme==='light') ? {
                            '& .MuiOutlinedInput-input': { color: Colors.light_text },
                            '& .MuiInputLabel-root': { color: Colors.light_text_accent },
                            borderRadius: 3
                        } : {
                            '& .MuiOutlinedInput-input': { color: Colors.dark_text },
                            '& .MuiInputLabel-root': { color: Colors.dark_text_accent },
                            borderRadius: 3
                        }}
                        value={mailBccEmail}
                        onChange={(event) => { setMailBccEmail(event.target.value) }}
                    />

                    <TextField
                        minRows={1}
                        autoComplete="off"
                        className={props.theme + '_accent _100perc margin_top_10px'}
                        id="mailErrorEmail"
                        label={props.t('error_email')}
                        size={'small'}
                        sx={(props.theme==='light') ? {
                            '& .MuiOutlinedInput-input': { color: Colors.light_text },
                            '& .MuiInputLabel-root': { color: Colors.light_text_accent },
                            borderRadius: 3
                        } : {
                            '& .MuiOutlinedInput-input': { color: Colors.dark_text },
                            '& .MuiInputLabel-root': { color: Colors.dark_text_accent },
                            borderRadius: 3
                        }}
                        value={mailErrorEmail}
                        onChange={(event) => { setMailErrorEmail(event.target.value) }}
                    />
                </div>
            </div>
        );
    }

    return (
        <div className={(props.screenWidth) < 600 ? 'not_expanded container_content _80perc ' + props.theme + ' container_content_' + props.theme : 'expanded container_content _80perc ' + props.theme + ' container_content_' + props.theme}>
            <FloatingBackButton onClick={() => { navigate("/" + props.lang + "/eticket"); }} />
            <FloatingSaveButton onClick={() => { save(); }} />

            <div className={"container_list__title " + props.theme}>
                <h2>E-custom - {name} {(storeId !== "00" || posId !== "0000") ? `(${storeId}/${posId})` : "(Default)"}</h2>
            </div>

            <br/><br/><br/><br/><br/>

            {loading && (
                <div className="rowContainerCenter">
                    <TailSpin
                        height="80"
                        width="80"
                        color={Colors.sft_blue}
                        ariaLabel='loading'
                    />
                </div>
            )}

            {!loading && (
                <Box className={props.theme + ' _100perc'}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }} className={props.theme + ' container_tabs_below_subtitle'}>
                        <Tabs value={value} onChange={handleChange} className={props.theme} variant="scrollable" scrollButtons="auto">
                            <Tab label={props.t('template')} {...a11yProps(0)} className={props.theme}/>
                            <Tab label="Logo" {...a11yProps(1)} className={props.theme}/>
                            <Tab label={props.t('mail_settings')} {...a11yProps(2)} className={props.theme}/>
                        </Tabs>
                    </Box>

                    <TabPanel value={value} index={0}>
                        {templateStep()}
                    </TabPanel>

                    <TabPanel value={value} index={1}>
                        {logoStep()}
                    </TabPanel>

                    <TabPanel value={value} index={2}>
                        {mailStep()}
                    </TabPanel>
                </Box>
            )}
        </div>
    );
}

export default EcustomDetailScreen;
